import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentType } from '../view-documents-dialog/view-documents-dialog';

@Component({
  selector: 'app-document-type-dialog',
  template: `
    <h2 mat-dialog-title>Select Document Category</h2>
    <mat-dialog-content>
      <div *ngIf="data?.fileName" class="file-info">
        <p><strong>File:</strong> {{data.fileName}}</p>
      </div>
      <mat-form-field appearance="fill">
        <mat-label>Document Category</mat-label>
        <mat-select [(ngModel)]="selectedType">
          <mat-option *ngFor="let type of documentTypes" [value]="type">
            {{type}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-button color="primary" [disabled]="!selectedType" (click)="onConfirm()">
        Confirm
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-form-field {
      width: 100%;
    }
    .file-info {
      margin-bottom: 16px;
      padding: 8px;
      border-radius: 4px;
      /* Use a subtle light overlay so text stays readable in dark mode */
      background-color: rgba(255, 255, 255, 0.08);
    }
    .file-info p {
      margin: 0;
    }
  `]
})
export class DocumentTypeDialogComponent {
  documentTypes = Object.values(DocumentType);
  selectedType: DocumentType | null = null;

  constructor(
    public dialogRef: MatDialogRef<DocumentTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    if (data?.currentType) {
      this.selectedType = data.currentType as DocumentType;
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close(this.selectedType);
  }
}
